import React from 'react';
import DollarImg from '../../Pages/images/latest/Dollar in hand.png';
import GlobeImg from '../../Pages/images/latest/Globe.png';
import DocImg from '../../Pages/images/latest/Doc.png';
import GrowthImg from '../../Pages/images/latest/Growth.png';
import VerifyImg from '../../Pages/images/latest/verify.png';
import './WhyItWorks.css';

const WhyItWorks = () => {
  const points = [
    {
      image: DollarImg,
      title: "PASSIVE INCOME",
      description: "Earn steady monthly returns with minimal effort."
    },
    {
      image: GlobeImg,
      title: "GLOBAL REACH",
      description: "Your container is utilized in global trade networks."
    },
    {
      image: DocImg,
      title: "MANAGED BY EXPERTS",
      description: "We handle leasing, operations, maintenance and logistics."
    },
    {
      image: GrowthImg,
      title: "GROWING DEMAND",
      description: "High demand for containers ensures consistent opportunities."
    },
    {
      image: VerifyImg,
      title: "SECURE & RELIABLE",
      description: "Your asset is protected and managed with transparency."
    }
  ];

  return (
    <div className="why-it-works-section">
      <div className="why-it-works-container">
        
        {/* Section Header */}
        <h2 className="why-it-works-title">
          WHY IT WORKS FOR YOU
        </h2>

        {/* Grid/Flex Container for the 5 points */}
        <div className="why-it-works-grid">
          {points.map((point, index) => (
            <div className="why-point-card" key={index}>
              <div className="why-point-icon-box">
                <img src={point.image} alt={point.title} className="why-point-img" />
              </div>
              <h3 className="why-point-title">{point.title}</h3>
              <p className="why-point-desc">{point.description}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default WhyItWorks;